__turbopack_context__.v({
  "Label": "t8rQBq_Label",
  "aboutField": "t8rQBq_aboutField",
  "aboutLabel": "t8rQBq_aboutLabel",
  "aboutLabelOptional": "t8rQBq_aboutLabelOptional",
  "aboutLabelText": "t8rQBq_aboutLabelText",
  "actionButton": "t8rQBq_actionButton",
  "badge": "t8rQBq_badge",
  "closeButton": "t8rQBq_closeButton",
  "col": "t8rQBq_col",
  "column": "t8rQBq_column",
  "content": "t8rQBq_content",
  "description": "t8rQBq_description",
  "field": "t8rQBq_field",
  "hint": "t8rQBq_hint",
  "illustration": "t8rQBq_illustration",
  "inputsLabel": "t8rQBq_inputsLabel",
  "inputsWrapper": "t8rQBq_inputsWrapper",
  "label": "t8rQBq_label",
  "link": "t8rQBq_link",
  "loader": "t8rQBq_loader",
  "logo": "t8rQBq_logo",
  "modal": "t8rQBq_modal",
  "modalContent": "t8rQBq_modalContent",
  "optImg": "t8rQBq_optImg",
  "optionContent": "t8rQBq_optionContent",
  "primary": "t8rQBq_primary",
  "prixClipFix": "t8rQBq_prixClipFix",
  "pulse": "t8rQBq_pulse",
  "root": "t8rQBq_root",
  "rotate": "t8rQBq_rotate",
  "row": "t8rQBq_row",
  "secondaryLabel": "t8rQBq_secondaryLabel",
  "teamOption": "t8rQBq_teamOption",
  "title": "t8rQBq_title",
});
